// extracted by mini-css-extract-plugin
module.exports = {"ExtrasLogoContainer":"ExtrasLogo_ExtrasLogoContainer__AQlSC","ExtraLogo":"ExtrasLogo_ExtraLogo__2eF-M"};